<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              placeholder="品牌/DMS订单号/发货单号/Delivery Note搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>

            <b-button
              size="sm"
              variant="outline-success"
              class="ml-2"
              @click="exportExcel()"
            >
              <i class="el-icon-folder-opened"></i>
              导出
            </b-button><!---->
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="110px">
        <el-row :gutter="20">
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item label="品牌">
              <el-input
                v-model="form.brandNo"
                placeholder="请输入品牌"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item label="DMS订单号">
              <el-input
                v-model="form.orderNo"
                placeholder="DMS订单号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item label="售价方编号">
              <el-input
                v-model="form.sourceNo"
                placeholder="请输入售价方编号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item label="售价方名称">
              <el-input
                v-model="form.sourceName"
                placeholder="请输入售价方名称"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item label="送达方编号">
              <el-input
                v-model="form.destNo"
                placeholder="请输入送达方编号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item label="送达方名称">
              <el-input
                v-model="form.destName"
                placeholder="请输入送达方名称"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item label="发货单号">
              <el-input
                v-model="form.shippingNo"
                placeholder="请输入发货单号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item label="Delivery Note">
              <el-input
                v-model="form.tmsOrderNo"
                placeholder="请输入Delivery Note单号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item label="订单接收日期">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginOrderReceiveDateStr"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endOrderReceiveDateStr"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item label="订单出库日期">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginShippingDateStr"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endShippingDateStr"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {...initForm},
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 普通查询
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {...initForm}
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    exportExcel(){
      let url = '/report/rpt/custm/delivery/note/by/item/export'
      let fileName = 'PFDC货物在途及异常追踪表（基于物料）'
      this.$api.globalExportData(url, this.form, fileName)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
